import { gql } from "lib/apolloClient";
import { controlParameterFragment } from "./RolesAndPermissionsFragments";

export const getOrganizationCoursesQuery = gql`
  query getOrganizationCourses(
    $organizationId: ID!
    $courseFilters: CourseFilterInput
  ) {
    node(id: $organizationId, type: ORGANIZATION) {
      id
      ... on Organization {
        id
        courses(filters: $courseFilters) {
          edges {
            node {
              id
              title
              curriculumProgram {
                id
                type
                acronym
              }
            }
          }
        }
      }
    }
  }
`;

export const getOrganizationLearningCoursesQuery = gql`
  query getOrganizationLearningCourses(
    $organizationId: ID!
    $learningCourseFilters: LearningCourseFilters
  ) {
    node(id: $organizationId, type: ORGANIZATION) {
      id
      ... on Organization {
        id
        learningCourses(filters: $learningCourseFilters) {
          edges {
            node {
              id
              title
              curriculumProgram {
                id
                type
                acronym
              }
            }
          }
        }
      }
    }
  }
`;

export const getRnPLevelsFeedQuery = gql`
  query getRnPLevelsFeed(
    $id: ID!
    $rnpViewFilters: RnpViewFilters!
    $academicYearId: ID
  ) {
    node(id: $id, type: ORGANIZATION) {
      ... on Organization {
        id
        rnpView(filters: $rnpViewFilters) {
          id
          ... on RnPRole {
            id
            label
            description
            globalLevel
            assignedUserCount(filters: { academicYearId: $academicYearId })
            assignedUserCountWithArchived(
              filters: { academicYearId: $academicYearId }
            )
            isDefaultRole
            isCustomRole
            isSuperAdmin
            globalRole {
              uid
            }
            displayUid
            presetRole {
              id
              label
            }
            createdAt
            createdBy {
              id
              firstName
              middleName
              lastName
              preferredName
              pronouns
              prefix
              suffix
            }
            updatedAt
            updatedBy {
              id
              firstName
              middleName
              lastName
              preferredName
              pronouns
              prefix
              suffix
            }
          }
        }
      }
    }
  }
`;

export const getRnPRoleDetailsQuery = gql`
  query getRnPRoleDetails($id: ID!, $rnpViewFilters: RnpViewFilters!) {
    node(id: $id, type: ORGANIZATION) {
      ... on Organization {
        id
        rnpView(filters: $rnpViewFilters) {
          id
          ... on RnPRole {
            id
            label
            isSuperAdmin
            isCustomRole
            assignedUserCount
          }
        }
      }
    }
  }
`;
export const getRnPPermissionsFeedQuery = gql`
  query getRnPPermisionsFeed(
    $id: ID!
    $roleId: ID!
    $globalLevels: [RNP_LEVEL_ENUM!]
  ) {
    node(id: $id, type: ORGANIZATION) {
      ... on Organization {
        id
        aclPermissionsListView(filters: { globalLevels: $globalLevels }) {
          displaySequence
          globalLevel
          type
          children
          childrenModules
          isChildrenModule
          relatedPermissions {
            id
            label
          }
          ...controlParameterItem
          associatedParent {
            ...controlParameterItem
          }
        }
      }
    }
  }
  ${controlParameterFragment.controlParameter}
`;

export const getRolesAssignedUsersFeedQuery = gql`
  query getRolesAssignedUsersFeed(
    $roleId: ID!
    $searchText: String
    $rnpRoleContextFilters: RnPRoleContextDetailFilterInput
    $assignedUsersContextFilters: RnPRoleContextDetailFilterInput
    $academicYearId: ID!
    $orderBy: ORDER_BY_ENUM
    $orderByDirection: ORDER_BY_DIRECTION
    $secondOrderBy: ORDER_BY_ENUM
    $secondOrderByDirection: ORDER_BY_DIRECTION
    $archivalState: ARCHIVAL_STATE_ENUM
    $after: String
    $first: Int
  ) {
    node(id: $roleId, type: RNP_ROLE) {
      ... on RnPRole {
        id
        assignedUsers(
          first: $first
          orderBy: $orderBy
          orderByDirection: $orderByDirection
          secondOrderBy: $secondOrderBy
          secondOrderByDirection: $secondOrderByDirection
          archivalState: $archivalState
          searchText: $searchText
          filters: $assignedUsersContextFilters
          after: $after
        ) {
          totalCount
          pageInfo {
            hasNextPage
            endCursor
          }
          edges {
            node {
              id
              email
              firstName
              lastName
              middleName
              prefix
              suffix
              preferredName
              pronouns
              type
              profileImage
              isArchived
              isArchivedV2(filters: { academicYearId: $academicYearId })
              rnpRoleContextDetail(filters: $rnpRoleContextFilters) {
                context {
                  id
                  ... on Organization {
                    id
                    name
                  }
                  ... on GenericCurriculumProgram {
                    id
                    type
                    acronym
                  }
                  ... on Course {
                    id
                    title
                    isArchived
                  }
                  ... on LearningCourse {
                    id
                    title
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

export const getStaffMembersMappedToRoleQuery = gql`
  query getStaffMembersMappedToRole(
    $roleId: ID!
    $after: String
    $first: Int
    $orderBy: ORDER_BY_ENUM
    $orderByDirection: ORDER_BY_DIRECTION
    $academicYearId: ID!
    $filters: RnPRoleContextDetailFilterInput
  ) {
    node(id: $roleId, type: RNP_ROLE) {
      ... on RnPRole {
        id
        assignedUsers(
          first: $first
          after: $after
          orderBy: $orderBy
          orderByDirection: $orderByDirection
          filters: $filters
        ) {
          totalCount
          pageInfo {
            hasNextPage
            endCursor
          }
          edges {
            node {
              id
              email
              firstName
              lastName
              middleName
              profileImage
              isArchived
              isArchivedV2(filters: { academicYearId: $academicYearId })
            }
          }
        }
      }
    }
  }
`;
